import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getOffsetRect } from '../helpers';
import * as GalleryActions from './GalleryActions';
import GalleryContainer from './GalleryContainer';
import GalleryMobileContainer from './GalleryMobileContainer';

class GalleryWrapperContainer extends Component {
    constructor() {
        super();

        this.state = {
            windowInnerWidth: window.innerWidth,
            error: null,
            errorInfo: null
        }
        this.onWindowResize = this.onWindowResize.bind(this);
        this.goToFullscreenGallery = this.goToFullscreenGallery.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize, false);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    goToFullscreenGallery(id, position) {
        if (!id && !position) {
            this.props.galleryActions.navigateToGallery({
                id: 'gallery',
                top: getOffsetRect(this.gallery).top
            });

            return false;
        }
        this.props.galleryActions.navigateToGallery({
            id,
            top: position
        });
    }

    onWindowResize() {
        this.setState({
            windowInnerWidth: window.innerWidth
        });
    }

    render() {
        const { images } = this.props;
        const { windowInnerWidth, error } = this.state;

        if (error || !images.length) {
            return null;
        }

        const galleryBlock = windowInnerWidth >= 768
            ? (
                <GalleryContainer goToFullscreenGallery={this.goToFullscreenGallery} />
            )
            : (
                <GalleryMobileContainer goToFullscreenGallery={this.goToFullscreenGallery} />
            );

        return (
            <div
                className="gallery-wrapper-container"
                id="gallery"
                ref={gallery => this.gallery = gallery}>
                <h2 className="section-header">photo gallery</h2>
                <p className='gallery-subheader'>Tap any photo for a full screen slide show.</p>
                {galleryBlock}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    images: state.gallery.images
});

const mapDispatchToProps = (dispatch) => ({
    galleryActions: bindActionCreators(GalleryActions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(GalleryWrapperContainer);